export enum UserResponsePresentationDataTypeEnum {
    PersonalTip = 1,
    MyManagerTip = 2,
    ConversationalQuestion = 7
}